import { ApisauceInstance, ApiResponse } from 'apisauce';

const getAvailableGroups = (
  api: ApisauceInstance,
): Promise<ApiResponse<{ groups: MicrosoftSso.Group[] }>> =>
  api.get<{ groups: MicrosoftSso.Group[] }>('/v1/sso/microsoft/groups');

export default getAvailableGroups;
